import { CalendarDays } from "lucide-react";

const DAY_ABBR = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

export function MiniCalendarStrip({ startDate, endDate }) {
  if (!startDate) return null;
  const start = new Date(startDate + "T00:00:00");
  const end = endDate ? new Date(endDate + "T00:00:00") : start;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const weekStart = new Date(start); weekStart.setDate(start.getDate() - start.getDay());
  const totalDays = Math.max(7, Math.ceil((end - weekStart) / 86400000) + 1);
  const daysToShow = Math.min(totalDays + (7 - totalDays % 7) % 7, 14);
  const days = [];
  for (let i = 0; i < daysToShow; i++) { const d = new Date(weekStart); d.setDate(weekStart.getDate() + i); days.push(d); }
  return (
    <div className="mt-3 pt-2 border-t border-border">
      <div className="flex items-center gap-1.5 mb-1.5">
        <CalendarDays className="w-3 h-3 text-muted-foreground" />
        <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          {startDate}{endDate && endDate !== startDate ? ` — ${endDate}` : ''}
        </span>
      </div>
      <div className="flex gap-0.5">
        {days.map((d) => {
          const isEvent = d >= start && d <= end;
          const isToday = d.getTime() === today.getTime();
          const ds = d.toISOString().split('T')[0];
          return (
            <div key={ds} className={`flex-1 text-center py-1 rounded-sm text-xs transition-colors ${isEvent ? 'bg-primary/25 text-primary font-semibold' : 'text-muted-foreground/40'} ${isToday ? 'ring-1 ring-primary' : ''}`}>
              <div className="text-[9px] leading-none mb-0.5">{DAY_ABBR[d.getDay()]}</div>
              <div className="text-[11px] leading-none">{d.getDate()}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
